<template>
  <div class="containe">
    <div class="forms-left">
      <div class="signin-signup">
        <span
          style="
            width: 100%;
            background: #0188c8;
            border-radius: 10px 10px 0 0;
            color: white;
            padding: 3px 0px;
            text-align: center;
            font-size: 25px;
          "
        >
          <strong style="font-size: 30px">Ω</strong> mega</span
        >
        <form action="#" class="sign-in-form" @submit.prevent>
          <div
            style="
              padding-top: 40px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 20px;
              width: 100%;
            "
          >
            <div class="input-field">
              <i><b-icon-envelope-fill font-scale="1.3" /></i>
              <input
                type="text"
                name="cpf"
                placeholder="Usuário"
                v-model="login.cpf"
              />
            </div>
            <div class="input-field">
              <i><b-icon-lock-fill font-scale="1.3" /></i>
              <input
                type="password"
                name="pass"
                placeholder="Senha"
                @keyup.enter="sendLogin"
                v-model="login.password"
              />
            </div>
            <span style="font-size: 12px"
              >Esqueceu a Senha? <a href="">Redefinir SENHA</a></span
            >
          </div>
          <button class="btn solid" @click="sendLogin">Entrar</button>
          <span style="font-size: 12px"
            >Realizar matrícula | <a href="">Matrícule-se</a></span
          >
        </form>
      </div>
    </div>
    <div class="rightLogo">
      <div style="padding-top: 100px">
        <div>
          <h1>
            Ω
            <span style="margin-left: -80px; font-size: 80px">mega</span>
          </h1>
        </div>
        <div>
          <h3
            style="
              margin-left: 30%;
              margin-top: -55px;
              font-size: 36px;
              color: rgb(255, 255, 255);
            "
          >
            Sistema de ensino
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CourseService from "../../services/course";
import { clearTokens } from "../../utils/clearTokens";

export default {
  data() {
    return {
      typeWaveAnimation: "",
      visibilitySaibaMais: "hideLogin",
      visibilityLogin: "showLogin",
      isCheck: false,
      isWarning: false,
      hourglass: true,
      infoNewClient: {},
      login: {
        cpf: "",
        password: "",
      },
      logger: {
        nome: "",
        cpf: "",
        password: "",
      },
      sectionsEnable: {
        login: true,
        tester: false,
        forgotMyPassword: false,
      },
      tipo: [
        { value: 1, text: "CPF" },
        { value: 2, text: "CNPJ" },
      ],
      invalidMessage: "",
    };
  },
  methods: {
    async sendLogin() {
      try {
        if (this.login.cpf === "" || this.login.password === "") {
          return this.$toast.open({
            message: "O campo login e senha devem ser preenchidos",
            type: "info",
          });
        }

        const { token } = await CourseService.auth({
          cpf: this.login.cpf,
          password: this.login.password,
        });

        localStorage.setItem("token", token.token);

        this.$router.push({ path: "/home" }).then(() => {
          location.reload();
        });
      } catch (error) {
        return this.$toast.open({
          message: "Verifique se o login e senha estão corretos!",
          type: "info",
        });
      }
    },

    clearAllInputs() {
      this.logger = {
        nome: "",
        email: "",
        password: "",
      };
    },

    verifyExitsToken() {
      if (!this.getToken) {
        const token = localStorage.getItem("token");
        if (token) {
          return this.$router.push({
            path: "/home",
          });
        }

        clearTokens();
      }
    },
  },
  computed: {
    ...mapState(["dataCompany"]),
    maskCelular() {
      return "(##) #####-####";
    },
    maskcpfcnpj() {
      if (this.company.cpfcnpj === null) {
        return "";
      }
      if (this.company.cpfcnpj.length <= 14) {
        return "###.###.###-##";
      }
      if (this.company.cpfcnpj.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },

    getToken() {
      return this.$route.query.token;
    },
  },
  mounted() {
    this.verifyExitsToken();
  },
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap"); */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: monospace;
}

body,
input {
  font-family: monospace;
}

.containe {
  position: relative;
  display: flex;
  width: 100vw;
  background-color: white;
  height: 100vh;
}

.forms-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rightLogo {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: #0188c8;
  border-radius: 200px 0 0 200px;
}

.signin-signup {
  width: 350px;
  height: 65%;
  border: 1px solid #f3f3f3;
  border-radius: 8px;
  display: flex;
  background: rgb(255, 255, 255);
  justify-content: center;
  align-content: space-between;
  flex-wrap: wrap;
  z-index: 100;
}

form {
  display: flex;
  align-items: center;
  gap: 50px;
  flex-direction: column;
  height: 100%;
}

.leftBkg {
  width: 40%;
  height: 50%;
  background: transparent;
  position: absolute;
  bottom: -5px;
  left: -5px;
  z-index: 20;
}

.rightBkg {
  width: 45%;
  height: 50%;
  background: transparent;
  position: absolute;
  top: -70px;
  right: -60px;
  z-index: 20;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.input-group {
  width: 100%;
  padding: 2px 0;
}

.user-label {
  position: absolute;
  left: 5px;
  font-size: 12px;
  z-index: 30;
  bottom: 15px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: transparent;
}
h1 {
  color: #fff;
  font-size: 320px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #c9c7c7;
  padding: 0 0.1em;
  font-weight: 600;
}

.fixedSelect {
  font-family: Arsenal-Medium, sans-serif;
  font-size: 11px !important;
  position: absolute;
  margin-bottom: 0px;
  padding: 0 5px;
  bottom: 28px;
  left: 10px;
  z-index: 2;
  color: #424146;
  background-color: #f0f0f038;
}

.borderInput {
  width: 100%;
  font-size: 11px;
  background-color: #f0f0f0;
  height: 35px;
  border: none;
  padding: 0 10px;
  border-radius: 10px;
}

.dividerInput {
  display: flex;
  width: 100%;
  gap: 5px;
}

.title {
  font-size: 2rem;
  color: #444;
  margin: 10px 0;
}

.input-field {
  max-width: 380px;
  width: 100%;
  border: 1px solid #e8e8e8;
  height: 40px;
  padding: 0 10px 0 0;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 15% 85%;
  position: relative;
  align-items: center;
}

.input-field i {
  text-align: center;
  line-height: 40px;
  color: #0188c8;
  transition: 0.5s;
  font-size: 12px;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 12px;
  color: #333;
}

.input-field input::placeholder {
  color: #aaa;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 30px whitesmoke inset !important;
  box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #575757 !important;
  height: 30px;
}

.social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn {
  width: 250px !important;
  background-color: #0188c8;
  border: none;
  outline: none;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 13px;
  margin: 10px 0;
  cursor: pointer;
  transition: 0.5s;
}

.btn:hover {
  background-color: #2f5cb0;
}

.image {
  width: 100%;
  transition: transform 1.1s ease-in-out;
  transition-delay: 0.4s;
}

.logo {
  width: 500px !important;
  height: 350px !important;
}

.logoIntro {
  width: 150px !important;
  height: 60px !important;
}

.logoFooter {
  width: 60px !important;
  height: 60px !important;
}

@media screen and (max-width: 700px) {
  .rightBkg {
    width: 50% !important;
    height: 30% !important;
  }
  .leftBkg {
    width: 35% !important;
    height: 20% !important;
  }
}

@media screen and (min-width: 1800px) {
  .signin-signup {
    width: 35%;
    height: 90%;
  }
  form {
    width: 100%;
  }
  .logoIntro {
    width: 300px !important;
    height: 130px !important;
  }
  .btn {
    width: 50% !important;
    font-size: 20px;
    height: 50px;
  }
  .input-field {
    max-width: none;
    width: 70%;
    height: 60px;
  }
  .input-field i {
    font-size: 22px;
  }
  input:-webkit-autofill {
    height: 50px;
  }
  .sign-in-form span {
    font-size: 20px !important;
  }
  .logoFooter {
    width: 100px !important;
    height: 100px !important;
  }
}
</style>
